import { apiFetch } from './api';

export interface QuoteRecord {
  id: number;
  name: string;
  company: string;
  email: string;
  phone: string | null;
  enzyme: string | null;
  message: string | null;
  country: string | null;
  city: string | null;
  ip_address: string | null;
  created_at: string;
}

export const fetchQuotes = (): Promise<QuoteRecord[]> =>
  apiFetch<QuoteRecord[]>('/aurel/quote/all');

export const deleteQuote = (id: number): Promise<{ message: string }> =>
  apiFetch<{ message: string }>(`/aurel/quote/${id}`, { method: 'DELETE' });
